$(function () {
    $('a[name = "showSecondCategory"]').on('click', showSecondCategory);
});

function showSecondCategory(e) {
    e.preventDefault();

    $('select[name = "second-category"]').fadeIn();
    $('select[name = "second-category"]').prop('disabled', false);
    
    $('a[name = "showSecondCategory"]').fadeOut();
    $('a[name = "showSecondCategory"]').remove();
}